/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Properties_EmptyInputs */

const cs_properties_empty = /** @type {(inputs: Properties_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné nemovitosti.`)
};

const en_properties_empty = /** @type {(inputs: Properties_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No properties yet.`)
};

/**
* | output |
* | --- |
* | "No properties yet." |
*
* @param {Properties_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const properties_empty = /** @type {((inputs?: Properties_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Properties_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_properties_empty(inputs)
	return cs_properties_empty(inputs)
});